import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancelledPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="text-center max-w-md px-6">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-red-600" strokeWidth={1.5} />
        </div>
        <h1 className="text-3xl font-heading font-bold text-[#0A2342] mb-4">
          Payment Cancelled
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Your payment was cancelled. No charges have been made to your account.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/cart">
            <Button 
              className="bg-[#0A2342] text-white hover:bg-[#0A2342]/90"
              data-testid="back-to-cart-btn"
            >
              Back to Cart
            </Button>
          </Link>
          <Link to="/products">
            <Button 
              variant="outline"
              data-testid="browse-products-btn"
            >
              Browse Products
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelledPage;